<template>
  <div class="app-viewport" id="file-list">
    <MainHeader
      :title=title
      :imageName=imageName
      :hasMaintenancne=hasMaintenancne
      :showMaintenanceInformation=showMaintenanceInformation
      @showWorkerCommentDialog="showWorkerCommentDialog"
      @showReportDialog="showReportDialog"
      @showSidePanel="showSidePanel"
    />
    <main class="main-content">
      <router-view/>
    </main>
    <WorkerCommentDialog
      :isShowWorkerCommentDialog=isShowWorkerCommentDialog
      btnTitle="閉じる"
      @close="closeWorkerCommentDialog"
    ></WorkerCommentDialog>
    <SidePanel :isShowSidePanel=isShowSidePanel @selectBox="selectBox" @maintenanceList="maintenanceList" @signOut="signOut" @close="closeDrawer"></SidePanel>
    <AxiosLoading :isShowAxiosLoading=$store.getters.axiosLoading></AxiosLoading>
    <ReportDialog :isShowReportDialog=isShowReportDialog @close="closeReportDialog" v-if="hasMaintenancne"></ReportDialog>
  </div>
</template>

<script>
  import MainHeader from '@/components/globals/MainHeader';
  import WorkerCommentDialog from '@/components/globals/WorkerCommentDialog';
  import SidePanel from '@/components/globals/SidePanel';
  import AxiosLoading from '@/components/globals/AxiosLoading';
  import ReportDialog from '@/components/globals/ReportDialog';

  export default {
    name: 'App',
    components: {
      MainHeader,
      WorkerCommentDialog,
      SidePanel,
      AxiosLoading,
      ReportDialog,
    },
    data() {
      return {
        title: '',
        imageName: '',
        showMaintenanceInformation: false,
        hasMaintenancne: false,
        isShowWorkerCommentDialog: false,
        isShowReportDialog: false,
        isShowSidePanel: false,
      };
    },
    methods: {
      showWorkerCommentDialog() {
        this.isShowWorkerCommentDialog = true;
      },
      showReportDialog() {
        this.isShowReportDialog = true;
      },
      showSidePanel() {
        this.isShowSidePanel = true;
      },
      closeWorkerCommentDialog(comment) {
        this.$store.dispatch('setComment', { comment });
        this.isShowWorkerCommentDialog = false;
      },
      closeReportDialog() {
        this.isShowReportDialog = false;
      },
      selectBox() {
        if (window.confirm('入力中のデータが消えますがよろしいですか？')) {
          this.isShowSidePanel = false;
          this.$router.push({name: 'SelectBox'})
        }
      },
      maintenanceList(route) {
        if (window.confirm('入力中のデータが消えますがよろしいですか？')) {
          this.hasMaintenancne = false;
          this.isShowSidePanel = false;
          this.$store.dispatch('getMaintenanceList')
            .then(() => { this.$router.push({ name: route }); })
            .catch((e) => {
              if (e.status == 401) {
                alert(e.data.error.message);
                this.$router.push({ name: 'SignIn', replace: true })
                return;
              }
              alert(e.data.error.message);
            });
        }
      },
      signOut() {
        if (window.confirm('ログアウトしますか？')) {
          this.isShowSidePanel = false;
          this.$router.push({ name: 'SignIn' })
        }
      },
      closeDrawer() {
        this.isShowSidePanel = false;
      },
    },
  };
</script>

<style lang="scss">

  @import "~vue-material/dist/theme/engine"; // Import the theme engine
  @include md-register-theme("default", (
    primary: md-get-palette-color(green, 500), // The primary color of your application
    accent: md-get-palette-color(pink, 500) // The accent or secondary color
  ));
  @import "~vue-material/dist/theme/all"; // Apply the the
  @import './assets/scss/app.scss';

  html,
  body,
  .app-viewport {
    height: 100%;
    overflow: hidden;
    background: #fafafa;
  }

  .app-viewport {
    display: flex;
    flex-flow: column;
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
    padding-bottom: 30px;

  }

  .main-toolbar {
    position: relative;
    z-index: 10;
  }

  .md-title {
    padding-left: 8px;
  }

  .main-content {
    height: 100%;
    position: relative;
    z-index: 1;
    overflow-x: hidden;
  }

  .flexbox-container {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    > div {
      width: 100%;
    }
  }

  * {
    font-size: 18px;
  }

  dl {
    dt, dd {
      text-align: left;
      padding: 0.5rem 1rem;
    }

    dt {
      border-bottom: 1px solid #cccccc;
    }
    dd {
      border-bottom: 1px solid #777777;
      min-height: 3rem;
    }
  }

  .md-dialog {
    z-index: 20;

  }
  .md-overlay {
    z-index: 10;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue?10594850